export default {
  name: 'Sven jens',
  email: 'sven@sven-jens.nl',
  phone: '0624345626',
};
